export default function TimedOut() {
    return (
        <div className="error timedOut">
            <h1>Timed Out</h1>
        </div>
    );
}
